var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipseBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 203,
    viewBox: "0 0 807 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 403.5,
    cy: 403.5,
    r: 403.5,
    fill: "url(#paint0_linear_4497_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4497_7",
    x1: 0,
    y1: 403.5,
    x2: 807,
    y2: 403.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A3519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B489D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseBottom);
export default __webpack_public_path__ + "static/media/eclipse_bottom.35d1b5ce237a4ef9f25ef5126f955531.svg";
export { ForwardRef as ReactComponent };